/**
 * A customer/shop name shown in its classification colour, everywhere a customer
 * appears. One component so the whole app reads the same: Trusted green, Cash-only
 * blue, Watch amber, High-risk red, Blacklisted deep red + struck through.
 *
 * Pass the classification the row's endpoint returns (undefined falls back to
 * Trusted/green, the database default). Use <ClassificationBadge> alongside when
 * the pill is wanted too; this is just the coloured name.
 */
import type { ReactNode } from 'react';
import { classificationNameStyle } from './ClassificationBadge';

export function CustomerName({ name, classification, className }: {
  name: ReactNode;
  classification?: string | null;
  className?: string;
}) {
  return (
    <span className={className} style={classificationNameStyle(classification)}>{name}</span>
  );
}
